import React, { useContext, useMemo } from "react";
import styles from "./index.module.scss";
import { Button, Icon, Tag } from "antd";
import Space from "../../../../../components/Space";
import classNames from "classnames";
import UserAvatar from "../../../Components/UserAvatar";
import { DiscussContent } from "../../context";
import TimeLimit from "./Components/TimeLimit";
import {
    isAskDetail,
    SpeakerType,
    TopicType
} from "../../../../../API/discuss";
import useDeviceType from "../../../../../Utils/useDeviceType";
import { isTrue } from "../../../../../Utils/filter";
import lodash from "lodash-es";
import { useHistory } from "react-router-dom";
import { BiUndo } from "react-icons/bi";

interface TopicProps {
    isFollow: boolean; // 是否已关注
}

export default function Topic({ isFollow }: TopicProps) {
    const {
        discussDetail,
        isDead,
        setIsWriting,
        setEditUuid,
        course,
        topicType
    } = useContext(DiscussContent);
    const { speakerType, speakerNo, speakerName } = discussDetail || {};
    const loginStuNo = localStorage.getItem("STUDENTNO");

    function onWrite() {
        if (topicType === TopicType.Discuss) {
            const answer = lodash.find(discussDetail?.replies, {
                canEdit: "1",
                delStatus: 0
            });

            if (answer) {
                setEditUuid(answer.uuid);
            } else {
                setEditUuid(null);
            }
        }
        setIsWriting(true);
    }

    const { isPC, isMobile } = useDeviceType();

    const replayBtn = useMemo(() => {
        if (isDead) {
            return null;
        }
        const node = (
            <Button icon="edit" onClick={onWrite}>
                写回答
            </Button>
        );
        if (isAskDetail(discussDetail)) {
            //自己发的，或者允许其他学生回答，返回回答按钮
            if (
                loginStuNo === discussDetail?.realAskerNo ||
                isTrue(discussDetail?.allowStudentAnswer)
            ) {
                return node;
            }
        } else {
            return node;
        }
    }, [discussDetail]);

    const history = useHistory();

    return (
        <div id="DiscussTopic" className={classNames("container", styles.root)}>
            <div className={styles.body}>
                {isPC && (
                    <Space className={styles.tags}>
                        <Tag color="blue">
                            {course?.courseName || discussDetail?.courseName}
                        </Tag>
                        <Button
                            size="small"
                            className="back"
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    </Space>
                )}

                <h1 className={styles.title}>
                    {isPC && topicType === TopicType.Ask && (
                        <UserAvatar
                            placement="bottomLeft"
                            isTeacher={speakerType === SpeakerType.Teacher}
                            userNo={speakerNo || ""}
                            userName={speakerName || ""}
                        />
                    )}
                    {discussDetail?.topicName}
                </h1>

                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html: discussDetail?.topicContent || ""
                    }}
                />

                {discussDetail && <TimeLimit data={discussDetail} />}
            </div>

            <div className={styles.tools}>
                <Space className={styles.buttons} size={10}>
                    {replayBtn}
                </Space>

                <Space className={styles.statics} size={20}>
                    <span>
                        <Icon type="solution" />
                        &nbsp;
                        {discussDetail?.statics?.partInCount}
                        人参与
                    </span>

                    <span>
                        <Icon type="message" />
                        &nbsp;
                        {discussDetail?.statics?.replyCount || 0} 条发言
                    </span>
                </Space>
            </div>
        </div>
    );
}
